<template>
    <div id="newContainer">
        <!-- 第一屏 -->
        <Screen1></Screen1>
        <!-- 第二屏 -->
        <Screen2></Screen2>
        <!-- 子路由（列表和文章） -->
        <router-view></router-view>
    </div>
</template>

<script>
import Screen1 from '@/components/news/Screen1.vue'
import Screen2 from '@/components/news/Screen2.vue'

export default {
    name: 'News',
    components: {
        Screen1,
        Screen2,
    },
    mounted(){
        this.$store.state.activeIndex = "/news"
    }
}
</script>

